// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.span-v-center {
  display: inline-flex;
  align-items: center;
}

select.form-control {
  height: unset !important;
}

.form-group {
  margin-bottom: 0;
}

.section-wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EDEDED;
}
@media (min-width: 768px) {
  .section-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  .section-wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.section-wrapper .title-wr {
  margin-top: 8px;
  margin-bottom: 10px;
}
.section-wrapper .title-wr .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.section-wrapper .form-check-label,
.section-wrapper .form-check-label.btn {
  opacity: 0.8;
  color: #382738;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 18px;
}
.section-wrapper .details-wrapper {
  margin-top: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #EDEDED;
  border-top: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
.section-wrapper .details-wrapper .title {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}
.section-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.section-wrapper .details-wrapper .action-text {
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.75px;
  line-height: 14px;
}
.section-wrapper .details-wrapper .item-wrapper {
  border: 1px solid lightgray;
  margin-bottom: 16px;
}
.section-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.section-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.section-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}

.buttons-wrap .btn {
  margin: 10px 0;
}

.request-footer .btn {
  height: 30px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}
.request-footer .btn-outline-dark {
  color: #382738;
  border: 1px solid #EBE9EB;
  background-color: #FFFFFF;
}

.additional-notes {
  color: #3E0D42;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 5px;
}

.notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  min-height: 180px;
  font-size: 12px;
}

.auto-margin {
  margin-top: auto;
  margin-bottom: auto;
}

.top20 {
  margin-top: 20px;
}

.content-offset {
  padding: 0 30px 0 30px;
}

.is-readonly {
  padding: 0;
  margin: 0;
  border: none;
}

.readonly-wrapper {
  padding: 20px 10px;
  border-top: 1px solid #EDEDED;
  border-bottom: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
@media (min-width: 576px) {
  .readonly-wrapper {
    padding: 28px;
  }
}
.readonly-wrapper .details-wrapper {
  padding-bottom: 18px;
}
.readonly-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.readonly-wrapper .details-wrapper .item-wrapper {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  margin-bottom: 12px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/requests/request-body/request-body.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AACF;AACE;EALF;IAMI,iBAAA;IACA,oBAAA;EAEF;AACF;AAAE;EAVF;IAWI,iBAAA;IACA,oBAAA;EAGF;AACF;AADE;EACE,eAAA;EACA,mBAAA;AAGJ;AADI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAGN;AACE;;EAEI,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AACN;AAEE;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;AAEI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAAN;AAGI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AADN;AAII;EACE,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAHN;AAMI;EACE,2BAAA;EACA,mBAAA;AAJN;AAMM;EACE,YAAA;AAJR;AAOM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AALR;AAQM;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AANR;;AAYE;EACE,cAAA;AATJ;;AAeE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAeE;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAbJ;;AAiBA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;AAfJ;;AAkBA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AAfJ;;AAkBA;EACI,gBAAA;EACA,mBAAA;AAfJ;;AAkBA;EACI,gBAAA;AAfJ;;AAkBA;EACI,sBAAA;AAfJ;;AAkBA;EACI,UAAA;EACA,SAAA;EACA,YAAA;AAfJ;;AAkBA;EACE,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,yBAAA;AAfF;AAiBE;EANF;IAOI,aAAA;EAdF;AACF;AAgBE;EACE,oBAAA;AAdJ;AAiBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAfN;AAkBI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAhBN;AAkBM;EACE,YAAA;AAhBR;AAmBM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAjBR;AAoBM;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAlBR","sourcesContent":[".span-v-center {\n    display: inline-flex;\n    align-items: center;\n}\n\nselect.form-control {\n    height: unset !important;\n}\n\n.form-group {\n    margin-bottom: 0;\n}\n\n.section-wrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #EDEDED;\n\n  @media (min-width: 768px) {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n\n  @media (min-width: 1024px) {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n\n  .title-wr {\n    margin-top: 8px;\n    margin-bottom: 10px;\n\n    .title-text {\n      color: #3E0D42;\n      font-size: 14px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 18px;\n    }\n  }\n\n  .form-check-label,\n  .form-check-label.btn {\n      opacity: 0.8;\n      color: #382738;\n      font-size: 13px;\n      font-weight: bold;\n      letter-spacing: 0.46px;\n      line-height: 18px;\n  }\n\n  .details-wrapper {\n    margin-top: 16px;\n    padding: 20px 0;\n    border-bottom: 1px solid #EDEDED;\n    border-top: 1px solid #EDEDED;\n    background-color: #FCFCFC;\n\n    .title {\n      color: #3E0D42;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.39px;\n      line-height: 15px;\n    }\n\n    .subtitle {\n      color: #6B556C;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.69px;\n      line-height: 22px;\n    }\n\n    .action-text {\n      margin-left: 12px;\n      // color: #29BB73;\n      font-size: 12px;\n      font-weight: bold;\n      letter-spacing: 0.75px;\n      line-height: 14px;\n    }\n\n    .item-wrapper {\n      border: 1px solid lightgray;\n      margin-bottom: 16px;\n\n      .item {\n        margin: 12px;\n      }\n\n      .item-name {\n        color: #3E0D42;\n        font-size: 13px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 16px;\n      }\n\n      .item-info {\n        opacity: 0.8;\n        color: #382738;\n        font-size: 11px;\n        letter-spacing: 0.55px;\n        line-height: 18px;\n      }\n    }\n  }\n}\n.buttons-wrap {\n  .btn {\n    margin: 10px 0;\n  }\n}\n.request-footer {\n  //margin-top: 22px;\n\n  .btn {\n    height: 30px;\n    border-radius: 3px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .btn-outline-dark {\n    color: #382738;\n    border: 1px solid #EBE9EB;\n    background-color: #FFFFFF\n  }\n}\n\n.additional-notes {\n    color: #3E0D42;\n    font-size: 12px;\n    font-weight: bold;\n\n    margin-bottom: 5px;\n}\n\n.notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    min-height: 180px;\n    font-size: 12px;\n}\n\n.auto-margin {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.top20 {\n    margin-top: 20px;\n}\n\n.content-offset {\n    padding: 0 30px 0 30px;\n}\n\n.is-readonly {\n    padding: 0;\n    margin: 0;\n    border: none;\n}\n\n.readonly-wrapper {\n  padding: 20px 10px;\n  border-top: 1px solid #EDEDED;\n  border-bottom: 1px solid #EDEDED;\n  background-color: #FCFCFC;\n\n  @media (min-width: 576px) {\n    padding: 28px;\n  }\n\n  .details-wrapper {\n    padding-bottom: 18px;\n\n\n    .subtitle {\n      color: #6B556C;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.69px;\n      line-height: 22px;\n    }\n\n    .item-wrapper {\n      border: 1px solid #EBE9EB;\n      border-radius: 3px;\n      margin-bottom: 12px;\n\n      .item {\n        margin: 12px;\n      }\n\n      .item-name {\n        color: #3E0D42;\n        font-size: 13px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 16px;\n      }\n\n      .item-info {\n        opacity: 0.8;\n        color: #382738;\n        font-size: 11px;\n        letter-spacing: 0.55px;\n        line-height: 18px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
